<template>
  <div class="data-list-container">
    <vs-row class="detailing_card">
      <!-- <vs-col class="lg:pr-2 pr-0 lg:w-5/12 sm:w-full mb-4">
        <vx-card title="Attach Tag" class="select-card h-full">
          <div class="flex flex-wrap items-center">
            <div class="w-full">
              <v-select
                class="w-full"
                label="name"
                taggable
                :create-option="
                  (option) => ({ id: option, label: option, name: option })
                "
                :options="tagModuleWise"
                v-model="tagSelected"
                :clearable="false"
                data-vv-name="tag_list"
                name="tag_list"
                multiple
                placeholder="Type and press enter to create a tag and then attach it."
              >
              </v-select>
            </div>
            <div class="w-full pt-2">
              <vs-button @click="checkingTagChanges(client_id)"
                >Attach Tag</vs-button
              >
            </div>
          </div>
        </vx-card>
      </vs-col> -->
      <vs-col class="w-full mb-4">
        <vs-card class="cstm_vx_card mb-0 h-full">
          <div class="flex flex-wrap justify-between" slot="header">
            <h4>Student Info</h4>
            <!-- <vs-tooltip color="primary" text="Call" position="top">
              <vs-button
                color="primary"
                vs-type="flex"
                :class="{ active: active_call }"
                >Activity
              </vs-button>
            </vs-tooltip> -->
          </div>
          <div class="sm:flex block flex-nowrap items-center" v-if="Object.keys(clientDetails).length !== 0">
            <div class="cstm_icon_holder">
              <span v-if="clientDetails.picture"><img :src="clientDetails.picture" width="100%" /></span>
              <span v-else class="material-icons">contacts</span>
            </div>
            <div class="w-full sm:pl-2 pl-0">
              <div class="detail_inform_card flex flex-wrap">
                <div class="p-2">
                  <vs-tooltip
                    class="flex items-center"
                    color="primary"
                    text="Name"
                    position="top"
                  >
                    <span class="material-icons">person_outline</span>
                    <span>{{clientDetails.first_name}} &nbsp; {{clientDetails.last_name}}</span>
                  </vs-tooltip>
                </div>
                <div class="p-2">
                  <vs-tooltip
                    class="flex items-center"
                    color="primary"
                    text="Mail"
                    position="top"
                  >
                    <span class="material-icons">mail</span>
                    <span>{{clientDetails.email}}</span>
                  </vs-tooltip>
                </div>
                <div class="p-2">
                  <vs-tooltip
                    class="flex items-center"
                    color="primary"
                    text="Phone"
                    position="top"
                  >
                    <span class="material-icons">phone</span>
                    <span>{{clientDetails.mobile}}</span>
                  </vs-tooltip>
                </div>
              </div>
              <!-- <vs-row class="mt-3" vs-justify="flex-end">
                <a href="#.">
                  <i
                    data-v-805c65ea=""
                    class="
                      vs-icon
                      notranslate
                      icon-scale
                      mr-3
                      account-icon
                      feather
                      icon-facebook
                      null
                    "
                  ></i>
                </a>
                <a href="#.">
                  <i
                    data-v-805c65ea=""
                    class="
                      vs-icon
                      notranslate
                      icon-scale
                      mr-3
                      account-icon
                      feather
                      icon-twitter
                      null
                    "
                  ></i>
                </a>
                <a href="#.">
                  <i
                    data-v-805c65ea=""
                    class="
                      vs-icon
                      notranslate
                      icon-scale
                      mr-3
                      account-icon
                      feather
                      icon-instagram
                      null
                    "
                  ></i>
                </a>
                <a href="#.">
                  <i
                    data-v-805c65ea=""
                    class="
                      vs-icon
                      notranslate
                      icon-scale
                      mr-3
                      account-icon
                      feather
                      icon-linkedin
                      null
                    "
                  ></i>
                </a>
              </vs-row> -->
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
    <div>
      <vs-table :data="details" class="cstm_vuexy_table w-full">
        <template slot="thead">
          <vs-th style="min-width: 105px" sort-key="first_name"
            >Course Name</vs-th
          >
          <vs-th style="min-width: 120px" sort-key="middle_name"
            >Course type</vs-th
          >
          <vs-th style="min-width: 105px" sort-key="last_name"
            >Teacher Name</vs-th
          >
          <!-- <vs-th style="min-width: 135px" sort-key="number"
            >Course Duration</vs-th
          > -->
          <vs-th style="min-width: 105px" sort-key="email"
            >Payment Type</vs-th
          >
          <!-- <vs-th style="min-width: 100px" sort-key="address1"
            >Payment receipts
          </vs-th> -->
          <vs-th style="min-width: 100px" sort-key="address2"
            >Payment Date</vs-th
          >
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].course_name">
              {{ data[indextr].course_name }}
            </vs-td>

            <vs-td :data="data[indextr].course_class_type">
              {{matchedCourseType(data[indextr].course_class_type)}}
            </vs-td>

            <vs-td :data="data[indextr].teacher_name">
              {{ data[indextr].teacher_name }}
            </vs-td>

            <!-- <vs-td :data="data[indextr].duration">
              {{ data[indextr].duration }}
            </vs-td> -->
            <vs-td :data="data[indextr].payment_type">
              {{ data[indextr].payment_type }}
            </vs-td>
            <!-- <vs-td :data="data[indextr].receipts">
              {{ data[indextr].receipts }}
            </vs-td> -->
            <vs-td :data="data[indextr].payment_date">
              {{ data[indextr].payment_date | dateFormatLocalization}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="text-right pt-4">
        <pagination
            :meta="meta"
            @page-change="handlePageChange"
          />
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select' 
import { Tag } from '@/mixins/tag/tag'
import { enrolledStudentsDetails } from '@/api/admission'
import pagination from '@/components/common/pagination'
export default {
  mixins: [Tag],
  components: {
    vSelect,
    pagination
  },
  data () {
    return {
      //sayantani
      client_id: parseInt(this.$route.params.studentId),
      platform_module_id: 48,
      details: [],
      clientDetails: {},
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10
      },
      courseClassTypeList:[
        {
          value:'self_based',
          name:'Self Paced Course'
        },
        {
          value:'online_one_2_one',
          name:'Online Individual Course'
        },
        {
          value:'online_one_2_many',
          name:'Online Group Course'
        },
        {
          value:'offline_one_2_one',
          name:'In Person Individual Course'
        },
        {
          value:'offline_one_2_many',
          name:'In Person Group Course'
        }
      ]
      //sayantani
      
    }
  },
  created () {
    this.enrolledStudentsDetails()
  },
  watch: {
    tagSelected () {
      this.filterTagList(this.platform_module_id)
      // this.fetchTag(this.platform_module_id, this.clientDetails.tags)
    }
  },
  methods: {
    async enrolledStudentsDetails () {
      try {
        const payload = {
          client_user_id: this.client_id
        }
        const data = await enrolledStudentsDetails(localStorage.getItem('customer_id'), this.query_page, payload)
        this.clientDetails = data.data.data.client_user
        this.details = data.data.data.details
        this.meta = data.data.data.meta
      } catch (e) {
        //
      }
    },
    handlePageChange (page) {
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.query_page.limit
      this.query_page.page = page
      this.$router
        .replace({ path: `/pages/admission/enrollment/${this.$route.params.studentId}`, query: queryPayload })
        .catch(() => {})
      this.enrolledStudentsDetails()
    },
    matchedCourseType (data) {
      const filteredData = this.courseClassTypeList.filter((item)=> {
        // eslint-disable-next-line eqeqeq
        return item.value == data
      }) 
      return filteredData[0].name
    }
  }
}
</script>
<style scoped>
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>